import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import {Link} from "react-router-dom";
import { animHeading, animPost, animTitles } from "../Animation";
import sanityClient from "../Client";


export default function AllPosts() {
  const [allPostsData, setAllPosts] = useState(null);

 

  useEffect(() => {
    //In our sanity studio we have set our blog post to be post. Here it fetches the data from sanity studio through grok query
    sanityClient
      .fetch(
        `*[_type == 'post']
        {
            title,
            slug,
            mainImage{
                asset->{
                    _id,
                    url
                }
            }
        }`
      )
      .then((data) => setAllPosts(data))
      .catch(console.error);
  }, []);

  return (
    <div className="bg-red-50 min-h-screen p-12">
     <div className="container mx-auto">
      <motion.h2 className="text-5xl font-bold uppercase flex justify-center mb-12" variants={animHeading} initial="hidden" animate="show">FashGram</motion.h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
          {allPostsData && allPostsData.map((post, index) => {
              return (
               <Link to={"/" + post.slug.current} key={post.slug.current}>
                   <span key={index} className="mb-3" >
                     <motion.img className="w-full h-full object-cover cardImage" src={post.mainImage.asset.url} alt="main hero for blog" variants={animPost} initial="hidden" animate="show"  whileHover={{ scale: 1.05 }} />
                     <span className="block flex justify-center">
                         <motion.h2 className="lg:text-2xl text-gray-900 mt-1" variants={animTitles} initial="hidden" animate="show" whileHover={{ scale: 1.1 }}>{post.title}</motion.h2>
                     </span>
                   </span>
               </Link>
               )
          })}
      </div>
      </div>
    </div>
  );
}
